import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import * as v from 'valibot'
import { getLocalizedRecordData } from 'src/i18n/localizedContent'
import type { Notification } from 'src/services/apollo/generated/graphql'
import { NotificationType } from 'src/services/apollo/generated/graphql'
import { localeAtom } from 'src/stores/locale'
import { getAppEnv } from 'src/utils/config'

const newsArticleSchema = v.object({
  title: v.string(),
  content: v.string(),
})

export type NewsArticleDataType = v.InferInput<typeof newsArticleSchema>

const emptyNewsData = { title: '', content: '' }

export function getNewsArticleData(lang: string, notification?: Notification) {
  if (notification?.type !== NotificationType.News) return emptyNewsData

  const localeData = getLocalizedRecordData(lang, notification.locales)

  const parsedData = v.safeParse(newsArticleSchema, localeData)
  if (!parsedData.success) {
    const appEnv = getAppEnv()
    if (appEnv.isDev) {
      console.warn('Invalid news article data', parsedData.issues)
    }
    return emptyNewsData
  }
  return parsedData.output
}

export function useMemoizedNewsArticleData(newsData?: Notification) {
  const locale = useAtomValue(localeAtom)
  return useMemo(() => getNewsArticleData(locale, newsData), [locale, newsData])
}
